export default function buildPathForEntity(path, id) {
  return `/${path}/${id}`;
}